import React from 'react';
import Head from './Head';

function Footer() {
    return (
        <>

            <section id="ubicacion" class="container mx-auto mt-8 px-6">
                <h2 class="text-2xl font-bold text-gray-800 mb-4">Visítanos</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div class="bg-white rounded-lg shadow-md p-6">
                        <p class="text-gray-700">Estamos ubicados en el corazón de la ciudad. ¡Ven a disfrutar del auténtico
                            sabor del kebab!</p>
                        <p class="text-gray-700 mt-2">Dirección: Calle Alcalde Alfonso Martínez de la Hoz, 10, Mancha Real, Jaén</p>

                    </div>
                    <div>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3169.973160246059!2d-3.6112608!3d37.7840106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd6e7b4eccf6b14d%3A0x2ad631162c3f2402!2sCasablanca%20kebab!5e0!3m2!1ses!2ses!4v1685800000000!5m2!1ses!2ses"
                            width="100%" height="300" allowfullscreen="" loading="lazy"></iframe>
                    </div>
                </div>
            </section>


            <footer class="bg-gray-800 text-white py-4">
                <div class="container mx-auto px-6 text-center">
                    <p>&copy; 2025 CasaBlanca Kebab. Todos los derechos reservados.</p>
                </div>
            </footer></>
    );
}

export default Footer;
